import { Briefcase, ArrowRight, Shield } from "lucide-react";
import { Button } from "../ui/button";

export function HeroSection({ onScrollToForm }) {
  return (
    <section className="relative overflow-hidden border-b border-zinc-200">
      <div className="max-w-6xl mx-auto px-6 py-20 lg:py-28">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 text-sm font-medium px-3 py-1 rounded-full mb-4">
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            Limited spots this week
          </div>
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-zinc-900 leading-[1.1]"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            Get interview-ready<br />
            <span className="text-[#002FA7]">job applications in 48 hours</span>
          </h1>
          <p className="mt-6 text-xl text-zinc-600 leading-relaxed max-w-2xl">
            We prepare job applications so you don't have to.
            Get 20-50 curated jobs with tailored cover letters and ready-to-send emails.
          </p>
          <p className="mt-4 text-sm font-medium text-zinc-800 flex items-center gap-2">
            <Shield className="w-4 h-4 text-green-600" />
            No auto-spam. Every job is manually reviewed.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Button
              onClick={onScrollToForm}
              data-testid="hero-cta-btn"
              className="bg-[#002FA7] text-white hover:bg-[#002280] rounded-sm px-8 py-6 text-lg font-semibold"
            >
              Get Started — It's $19 <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export function StatsBar() {
  const stats = [
    { value: "20-50", label: "Curated Job Matches" },
    { value: "10+", label: "Tailored Cover Letters" },
    { value: "48h", label: "Delivery Time" },
    { value: "100%", label: "Human-Reviewed" },
  ];

  return (
    <section className="bg-[#002FA7] text-white">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-6 text-center">
          {stats.map((s) => (
            <div key={s.label}>
              <p className="text-3xl font-bold">{s.value}</p>
              <p className="text-blue-200 text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
